<template>
  <v-container fluid fill-height class="px-0">
    <v-row>
      <v-col cols="12" xl="4" lg="4" class="d-flex flex-column">
        <BioactiveProductionList />
      </v-col>
      <v-col cols="12" xl="8" lg="8" class="d-flex flex-column">
        <CeparioProductionDetail />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// components
import BioactiveProductionList from "@/components/cepario-production/BioactiveProductionList";
import CeparioProductionDetail from "@/components/cepario-production/CeparioProductionDetail";
// date library
import dayjs from "dayjs";
export default {
  components: {
    BioactiveProductionList,
    CeparioProductionDetail,
  },
  data: () => ({}),
  mounted() {},
  methods: {
    // hello() {
    //   this.$swal({
    //     icon: "success",
    //     title: `Bienvenido`,
    //     showConfirmButton: false,
    //     timer: 2000,
    //   });
    // },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
  },
};
</script>
